import request from '@/utils/request'

//  获取应用列表
export const getApplicationList = (params: any) =>
  request({
    url: '/manage/enterprise-app',
    method: 'get',
    params
  })

// 获取应用列表详情
export const getApplicationListInfo = (params: any) =>
  request({
    url: '/manage/enterprise-app/' + params.id,
    method: 'get',
    params
  })

// 创建应用
export const addApplication = (data: any) =>
  request({
    url: '/manage/enterprise-app',
    method: 'post',
    data
  })

// 编辑应用
export const modifyApplication = (data: any) =>
  request({
    url: '/manage/enterprise-app/' + data.id,
    method: 'patch',
    data
  })

// 删除应用
export const delApplication = (data: any) =>
  request({
    url: `/manage/enterprise-app/${data.id}`,
    method: 'patch',
    data
  })

// 获取应用配置
export const applicationConfig = (params: any) =>
  request({
    url: '/manage/corporation',
    method: 'get',
    params
  })

// 切换应用
export const switchApplication = (data: any) =>
  request({
    url: '/manage/jump/enterprise',
    method: 'post',
    data
  })

// 支付平台信息接口
export const paymentPlatformDetails = () =>
  request({
    url: '/manage/enterprise',
    method: 'get'
  })
